const scope = "factorAttribution";
export default scope;